import React, { useEffect, useState } from "react";
import { useIntl } from "react-intl";
import { useDispatch, useSelector } from "react-redux";
import { Button, Box } from "@mui/material";
import AppInfoView from "@crema/core/AppInfoView";
import AppsContainer from "@crema/core/AppsContainer";
import AppsPagination from "@crema/core/AppsPagination";
import AppsContent from "@crema/core/AppsContainer/AppsContent";
import AppsHeader from "@crema/core/AppsContainer/AppsHeader";
import { AppState } from "redux/store";
import AppellateTable from "./AppellatePageTable";
import { getAllAppellates } from "redux/actions";


const Appellate = () => {
  const { messages } = useIntl();
  const dispatch = useDispatch();
  const rowsPerPage = 50;
  const { appellate } = useSelector<AppState, AppState["appellateMaster"]>(
    ({ appellateMaster }) => appellateMaster
  );
  
  const [page, setPage] = useState(0);

  

  const exportAppellateToCSV = (appellateData: any[]) => {
  if (!appellateData || appellateData.length === 0) {
    alert("No appellate data available to export.");
    return;
  }

  const sanitize = (value: any) =>
    String(value ?? "")
      .replace(/,/g, " ")
      .replace(/\r?\n|\r/g, " ");

  const headers = [
    "Date",
    "Customer ID",
    "Ticket ID",
    "Source",
    "Reference",
    "Name",
    "Mobile",
    "Email",
    "Remarks",
  ];
  const csvRows: string[] = [headers.join(",")];

  appellateData.forEach((item) => {
    const row = [
      sanitize(item?.createdAt),
      sanitize(item?.source),
      sanitize(item?.reference),
      sanitize(item?.name),
      sanitize(item?.mobile),
      sanitize(item?.email),
      sanitize(item?.message),
    ];
    csvRows.push(row.join(","));
  });

  const csvString = csvRows.join("\n");
  const blob = new Blob([csvString], { type: "text/csv;charset=utf-8;" });

  const link = document.createElement("a");
  link.href = URL.createObjectURL(blob);
  link.setAttribute("download", "appellate.csv");
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};


  const onPageChange = (
    event: React.ChangeEvent<unknown> | null,
    value: number
  ) => {
    setPage(value);
  };

  useEffect(() => {
        dispatch(getAllAppellates());
      }, [dispatch]);

 return (
    <>
      <AppsContainer
        title={
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              width: "100%",
            }}
          >
            <Box
              component="span"
              sx={{
                fontSize: 16,
                fontWeight: "bold",
                color: "text.primary",
                flex: 1,
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
              }}
            >
              {messages["sidebar.appellateMaster"]}
            </Box>
 
            <Button
              variant="contained"
              color="secondary"
              onClick={() => exportAppellateToCSV(appellate)}
            >
              Export
            </Button>
          </Box>
        }
        fullView
      >
        <AppsHeader>{null}</AppsHeader>

        <AppsContent
          sx={{
            paddingTop: 2.5,
            paddingBottom: 2.5,
            display: "flex",
            flexDirection: "column",
            flexGrow: 1,
          }}
        >
          <AppellateTable appellate={appellate} />
          <AppsPagination
            rowsPerPage={rowsPerPage}
            count={appellate.length}
            page={page}
            onPageChange={onPageChange}
          />
        </AppsContent>
      </AppsContainer>

      <AppInfoView />

      <AppInfoView />
    </>
  );
};

export default Appellate;
